import { FC, memo, useState } from "react";

import { XCircleFill } from "@hl/base-components/lib/assets/icons.generated";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { maskAddress } from "@hl/shared-features/lib/utils/content";
import { Button } from "@mantine/core";
import dayjs from "dayjs";

import { UnlinkEmailModal } from "~/features/account/email/UnlinkEmailModal";

type ProvidedEmailRowProps = {
  id: string;
  walletAddress: string;
  ensName?: string;
  grantedAccess: Date;
};

const ProvidedEmailRow: FC<ProvidedEmailRowProps> = ({
  id,
  walletAddress,
  ensName,
  grantedAccess,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <tr key={id}>
      <td>{ensName || maskAddress(walletAddress, 6)}</td>
      <td>{dayjs(grantedAccess).format("MMMM DD[,] YYYY [at] HH:mm")}</td>
      <td>
        <Button p={8} color={SECONDARY_COLOR} onClick={() => setIsOpen(true)}>
          <XCircleFill />
        </Button>
      </td>
      <UnlinkEmailModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        creatorId={id}
        walletAddress={walletAddress}
        ensName={ensName}
      />
    </tr>
  );
};

export default memo(ProvidedEmailRow);
